import React, { Fragment } from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import withAuth from '../auth/withAuth';
import * as AuthStates from '../auth/AuthStates';
import * as Routes from './Routes';
import { Validations, ToolPermissions } from '../utils';
import { AuthRoles } from '../auth';
import { ErrorBoundary, PageLoader } from '../components';

const PrivateRoute = withRouter(
  withAuth(({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={props => {
        // if authState not loading or signedIn, redirect to login
        switch (rest.authState) {
          case AuthStates.SignedIn: {
            /* This variable is to check if we're already at home.
            We need this otherwise there will be an infinite loop is wrapped component is a landing page*/
            const isOnLandingPage = window.location.pathname === Routes.home;
            const isAuthorized = rest.authUser && rest.authUser.isAuthorized;

            // check to see if user has a SuperUser role
            const isAGIUser = AuthRoles.isAGIUser(rest.authUser, 'roles');

            // if role prop passed along, the route is gated for the role only
            const hasRequiredRole =
              isAuthorized && rest.roles
                ? Validations.hasRole(rest, 'authUser.roles', rest.roles)
                : true;
            // if gate prop passed along, the route should be gated from the specified role
            const shouldGate = Validations.hasRole(
              rest,
              'authUser.roles',
              rest.gate
            );

            const userHasPermissionToAccessTool = (
              pathname,
              routePermissions
            ) => {
              /* //////
              // determines if the user can view the a particular route based
              // on their tool permissions page;
              // if no permissions found -- user can access by default
              ///// */
              let canAccess = true;
              if (pathname === '/priceLists') {
                return canAccess;
              }
              const { tools } = rest.authUser;
              const currentPageHasPermissions = routePermissions.find(
                obj => obj.route === pathname
              );
              if (currentPageHasPermissions !== undefined) {
                canAccess = tools[currentPageHasPermissions.toolPermissionKey];
              }
              return canAccess;
            };

            if (
              !isOnLandingPage &&
              (!isAuthorized ||
                (!hasRequiredRole && !isAGIUser) ||
                (rest.gate && shouldGate && !isAGIUser) ||
                (!isAGIUser &&
                  !userHasPermissionToAccessTool(
                    props.location.pathname,
                    ToolPermissions.routeToolPermissions
                  )))
            ) {
              return (
                <Redirect
                  to={{
                    pathname: Routes.home,
                    state: { from: props.location }
                  }}
                />
              );
            } else {
              // else return the required component.
              return (
                <Fragment>
                  <ErrorBoundary>
                    <Component {...props} />
                  </ErrorBoundary>
                  <Helmet>
                    <script
                      id="ze-snippet"
                      src="https://static.zdassets.com/ekr/snippet.js?key=a077ff89-d68d-462c-b52b-f555225c906a"
                    />
                  </Helmet>
                </Fragment>
              );
            }
          }
          case AuthStates.Loading:
            return <PageLoader fixed />;
          default:
            return (
              <Redirect
                to={{ pathname: Routes.login, state: { from: props.location } }}
              />
            );
        }
      }}
    />
  ))
);

export default PrivateRoute;
